export default `
	badge
	headline
	images {
		filename
		height
		id
		size
		url
		width
	}
	listHeadings {
		...on ListHeadingsItem {
			heading
		}
	}
`;
